import { Accordion, AccordionContent, AccordionHeader, AccordionIcon, AccordionItem, AccordionTrigger } from "components/ui";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react-native";
import React, { ReactNode } from "react";

interface AccordionDropdownProps {
	headerContent: ReactNode;
	children: ReactNode;
}

const AccordionDropdown = (props: AccordionDropdownProps) => {
	return (
		<Accordion>
			<AccordionItem value="a">
				<AccordionHeader>
					<AccordionTrigger padding={0}>
						{({ isExpanded }) => {
							return (
								<>
									{props.headerContent}
									{/* <AccordionTitleText>How do I place an order?</AccordionTitleText> */}
									{isExpanded ? <AccordionIcon as={ChevronUpIcon} ml="$3" /> : <AccordionIcon as={ChevronDownIcon} ml="$3" />}
								</>
							);
						}}
					</AccordionTrigger>
				</AccordionHeader>
				<AccordionContent padding={0}>{props.children}</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};

export default AccordionDropdown;
